"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intlI18n = require("@/i18n/intl-i18n");
var _IntlHeader = _interopRequireDefault(require("./components/IntlHeader.vue"));
var _IntlFooter = _interopRequireDefault(require("./components/IntlFooter.vue"));
var _intlMobileStyles = _interopRequireDefault(require("./mobile/intl-mobile-styles.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// ============================================================
// 国际专区布局容器逻辑
// ============================================================
var _default = exports.default = {
  name: 'InternationalLayout',
  mixins: [_intlI18n.intlMixin],
  components: {
    IntlHeader: _IntlHeader.default,
    IntlFooter: _IntlFooter.default
  },
  mounted: function mounted() {
    // 动态注入移动端覆盖样式 — JS 字符串不被 postcss-px2rem 转换，px 保持原始像素
    var styleEl = document.createElement('style');
    styleEl.id = 'intl-mobile-styles';
    styleEl.textContent = _intlMobileStyles.default;
    document.head.appendChild(styleEl);
  },
  beforeDestroy: function beforeDestroy() {
    var el = document.getElementById('intl-mobile-styles');
    if (el) el.remove();
  }
};